import { isEmpty } from 'lodash-es'
import { useEffect, useState } from 'react'

export const usePageLoad = (onPageLoad: () => void, shouldExecute = true) => {
    const [pageLoaded, setPageLoaded] = useState(false)
    useEffect(() => {
        if (!pageLoaded && shouldExecute) {
            onPageLoad()
            setPageLoaded(true)
        }
    }, [onPageLoad, pageLoaded, shouldExecute])
}

export const usePageLoadV2 = (onPageLoad: () => void, dependencies: Array<string>) => {
    const [pageLoaded, setPageLoaded] = useState(false)
    const areBothPopulated = (value: Array<string>) => {
        if (isEmpty(value)) return false

        let result = true
        value.forEach((item) => {
            if (isEmpty(item)) result = false
        })
        return result
    }
    useEffect(() => {
        if (!pageLoaded && areBothPopulated(dependencies)) {
            onPageLoad()
            setPageLoaded(true)
        }
    }, [onPageLoad, pageLoaded, dependencies])
}
